import { render, staticRenderFns } from "./done-tab1.vue?vue&type=template&id=3f1bdebc&"
import script from "./done-tab1.vue?vue&type=script&lang=ts&"
export * from "./done-tab1.vue?vue&type=script&lang=ts&"
import style0 from "./done-tab1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports